import React from "react";
import { PickersShortcutsProps } from "@mui/x-date-pickers";
import { Chip, List, ListItem, styled } from "@mui/material";
import { Dayjs } from "dayjs";
import { FC } from "../../../types";
import { pickersShortcutsStyles } from "./PickersShortcuts.styled";

export interface RangePickersShortcutsProps<TValue>
  extends Omit<PickersShortcutsProps<[TValue, TValue]>, "isValid"> {
  isValid(value: TValue): void;
}

export const RangePickersShortcuts: FC<
  RangePickersShortcutsProps<Dayjs | null>
> = (props) => {
  const {
    items,
    onChange,
    className,
    isValid,
    changeImportance = "accept",
  } = props;

  if (!items || items.length === 0) {
    return null;
  }

  const handleIsValid = (values: [Dayjs | null, Dayjs | null]) => {
    const areValuesValid = values.every(isValid);

    const isValidRange =
      values[0]?.isBefore(values[1]) || values[0]?.isSame(values[1]);

    return areValuesValid && !!isValidRange;
  };

  const resolvedItems = items.map((item) => {
    const newValue = item.getValue({ isValid: handleIsValid });

    return {
      label: item.label,
      onClick: () => {
        onChange(newValue, changeImportance, item);
      },
      disabled: !handleIsValid(newValue),
    };
  });

  return (
    <List dense className={className}>
      {resolvedItems.map((item) => {
        return (
          <ListItem key={item.label}>
            <Chip {...item} />
          </ListItem>
        );
      })}
    </List>
  );
};

export const StyledRangePickersShortcuts = styled(RangePickersShortcuts)(
  pickersShortcutsStyles,
);
